var _style, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubetBluedark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 154.4",
    style: {
      enableBackground: "new 0 0 496.2 154.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000116225818949796258160000005684463336776778428_);}\n\t.st2{fill:url(#SVGID_00000182521930467675416610000002040538310582415292_);}\n\t.st3{fill:url(#SVGID_00000021807322193474237750000004046451254402866594_);}\n\t.st4{fill:#FACC00;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.2688,
    y1: 1156.9812,
    x2: 60.2688,
    y2: 1080.9812,
    gradientTransform: "matrix(1 0 0 1 0 -1041.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5382,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7995,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "91.9,39.1 76.3,84.3 54.6,39.1 29.1,39.1 3.1,114.1 3.1,115.1 28.3,115.1 43.9,69.9 66.9,115.1  91.1,115.1 117.4,39.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111148858602473142970000006849485515459729291_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.8921,
    y1: 1156.9812,
    x2: 396.8921,
    y2: 1080.9812,
    gradientTransform: "matrix(1 0 0 1 0 -1041.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D589A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    style: {
      stopColor: "#3DA3FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D589A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111148858602473142970000006849485515459729291_)"
    },
    d: "M402.7,39.1L402.7,39.1h-69.3 c-5.2,0-9.9,3.1-11.4,7.6L303.2,101c-2.4,7,3.3,14.1,11.4,14.1h61.8l6.4-18.4h-52.6l2.1-6.2l-6.3-5.7h16.4l0,0h38.7l5.3-15.4h-46.7 l1.6-4.5l-8.2-7.4h10.7l0,0h52.4h31.5l-19.9,57.6h25.5l17.1-49.4l-9-8.2h11.8l0,0h31.5l6.4-18.4H402.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102531220251066655470000007854491925077371542_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.4501,
    y1: 1156.9812,
    x2: 162.4501,
    y2: 1080.9812,
    gradientTransform: "matrix(1 0 0 1 0 -1041.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5382,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7995,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102531220251066655470000007854491925077371542_)"
    },
    d: "M194.7,77.1c0-8.3,6.6-15,14.8-15.3 l7.8-22.7h-25.5l-19.5,56.3c-0.3,0.9-1,1.4-2.1,1.4h-34.1c-1.1,0-1.6-0.5-1.3-1.4l19.5-56.3h-25.5l-20.3,58.7 c-1.7,4.9-1.1,9,1.9,12.3s7.5,5,13.5,5h49.7c6,0,11-1.7,14.9-5c4-3.3,6.8-7.4,8.6-12.3l3.1-8.9C196.8,86,194.7,81.8,194.7,77.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135689771546621807890000012677686800504516485_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.8389,
    y1: 1156.9812,
    x2: 253.8389,
    y2: 1080.9812,
    gradientTransform: "matrix(1 0 0 1 0 -1041.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D589A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    style: {
      stopColor: "#3DA3FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D589A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135689771546621807890000012677686800504516485_)"
    },
    d: "M305.5,48.8c-0.5-3-2.2-5.4-5.1-7.1 c-2.9-1.7-6.6-2.6-11.1-2.6h-61.1l-8.9,25.8c3.7,2.8,6,7.2,6,12.2c0,8.5-6.9,15.4-15.4,15.4c-0.1,0-0.1,0-0.2,0l-7.8,22.6h69.6 c4.4,0,8.4-1.1,12-3.4s6.6-5,9.1-8.4c2.4-3.3,4.2-6.9,5.3-10.8c1.1-3.8,1.4-7.4,0.8-10.6c-0.7-3.8-2.4-6.6-5.1-8.4 c1.6-1,3.3-2.5,4.9-4.4c1.6-2,3-4.2,4.1-6.5c1.1-2.4,2-4.8,2.6-7.2C305.8,52.9,305.9,50.7,305.5,48.8 M272.6,89.8l-0.6,1.7 c-0.4,1.4-1.5,2.6-3.1,3.7s-3.4,1.6-5.2,1.6h-29.8l2.4-6.8l-6.1-5.5h8l0,0H268c2.9,0,4.5,1,4.8,3.1 C272.9,88.1,272.9,88.9,272.6,89.8 M277.5,62.7l-0.5,1.5c-0.5,1.5-1.6,2.7-3.2,3.8c-1.6,1.1-3.4,1.6-5.2,1.6h-25.4l2-5.9l-7-6.3 h9.2v-0.1h25.4c2.9,0,4.5,1.1,4.9,3.4C277.8,61.5,277.8,62.2,277.5,62.7"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210,64.7c-6.9,0-12.4,5.6-12.4,12.4c0,6.9,5.6,12.4,12.4,12.4s12.4-5.6,12.4-12.4 C222.5,70.2,216.9,64.7,210,64.7 M216.6,84.6c2.5-3.3,2.8-7.9,0.3-11.5c-3.1-4.5-9.2-5.7-13.7-2.6c1.9-2.5,4.9-4,8.3-3.9 c5.4,0.2,9.7,4.8,9.4,10.3C220.8,80.1,219.1,82.9,216.6,84.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubetBluedark);
export default __webpack_public_path__ + "static/media/nubet_bluedark.b213ee80670b7a79824b4d9a795dbd49.svg";
export { ForwardRef as ReactComponent };